/**
 * aligned's `managers` collection (`models/manager/manager/manager_model.dart`).
 * A manager account links a `user_accounts` doc to a `customers` doc. A single
 * user can have more than one `Manager` doc (e.g. after "Connect Company" in
 * onboarding) — see `services/managers.ts:getManagerByUserAccountId`.
 */
export interface Manager {
  id: string;
  firebaseId: string;
  userAccountId: string;
  userAccountEmail: string | null;
  customerId: string;
  isSelfServe: boolean;
  isFirstTime: boolean;
  projectForModelComparison: string | null;
  projectForAutotune: string | null;
}

type Data = Record<string, unknown>;

const str = (v: unknown): string | null => (typeof v === 'string' ? v : null);
const bool = (v: unknown, dflt: boolean): boolean => (typeof v === 'boolean' ? v : dflt);

export function mapManager(id: string, data: Data): Manager {
  return {
    id,
    firebaseId: str(data.firebaseId) ?? '',
    userAccountId: str(data.userAccountId) ?? '',
    userAccountEmail: str(data.userAccountEmail),
    customerId: str(data.customerId) ?? '',
    isSelfServe: bool(data.isSelfServe, false),
    isFirstTime: bool(data.isFirstTime, false),
    projectForModelComparison: str(data.projectForModelComparison),
    projectForAutotune: str(data.projectForAutotune),
  };
}
